import { z } from "@reflag/shared/utils/zod";

export const NotificationProviderSchema = z.enum(["linearComment", "slack"]);

export type NotificationProvider = z.infer<typeof NotificationProviderSchema>;

export const NotificationProviderTitle: Record<NotificationProvider, string> = {
  linearComment: "Linear comment",
  slack: "Slack message",
};
